import styled from "styled-components";
import { Button } from "antd";
import { color } from "../../../resources/color";

export const ContainerSearch = styled.div<{
  children: any;
}>`
  height: 20px;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const ContainerDevice = styled.div<{
  children: any;
}>`
  display: flex;
`;

export const ContainerDataDevice = styled.div<{
  children: any;
}>`
  width: 35%;
  padding: 3;
`;

export const ContainerImportDevice = styled.div<{
  children: any;
}>`
  width: 65%;
  padding: 3;
`;
export const HeaderButtonImportDevice = styled.div<{
  children: any;
}>`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const DivButtonImportDevice = styled.div<{
  children: any;
}>`
  display: flex !important;
  flex-wrap: warp;
`;

export const DivButtonPreview = styled.div<{
  children: any;
}>`
  display: flex !important;
  margin: 0;
  justify-content: flex-end;
`;

export const DivTableData = styled.div<{
  children: any;
}>`
  margin-top: 10px;
`;

export const DivNoPreview = styled.div`
  margin: 10px;
`;

export const ButtonUploadFileExcel = styled(Button).attrs((_props) => ({
  type: "secondary",
}))`
  background-color: none;
  min-width: 120px;
  border-radius: 120px;
  font-size: 14px;
  border-color: ${color.btn_primary};
  color: ${color.btn_primary};
  &:hover,
  &:focus {
    background-color: none;
    border-color: ${color.btn_primary}DD;
    color: ${color.btn_hover_primary}DD;
  }
`;

export const DivButtonExportFile = styled.div<{
  children: any;
}>`
  display: flex !important;
  justify-content: flex-end;
  margin-bottom: 5px;
`;
